import React, { useEffect, useState, useRef } from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import api from '../../axiosConfig';
import Modal from 'bootstrap/js/dist/modal';


export default function TablaDescargas() {
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [editingUser, setEditingUser] = useState(null);

    useEffect(() => {
        getDatos();
    }, [page, limit, search]);



    const getDatos = async () => {
        try {
            const res = await api.get(
                `/api/downloads/table?inicio=${(page - 1) * limit}&longitud=${limit}&orden=desc&ordenColumn=created_at&cadena=${search}`
            );
            setData(res.data.data);
            //setTotal(res.data.recordsTotal);
            setTotal(res.data.recordsFiltered);
        } catch (err) {
            console.error("Error al obtener datos:", err);
        }
    };



    // Helper: robust date parser for hook-provided values
    function toDateSafe(input) {
        if (input == null) return null;
        if (input instanceof Date) return isNaN(input.getTime()) ? null : input;
        if (typeof input === "number") {
            const d = new Date(input);
            return isNaN(d.getTime()) ? null : d;
        }
        if (typeof input === "string") {
            const s = input.trim();
            if (!s) return null;
            const d = new Date(s);
            return isNaN(d.getTime()) ? null : d;
        }
        if (typeof input === "object" && ("seconds" in input)) {
            const ms = (input.seconds * 1000) + Math.floor((input.nanoseconds || 0) / 1e6);
            const d = new Date(ms);
            return isNaN(d.getTime()) ? null : d;
        }
        return null;
    }

    function formatearFecha(fechaInput) {
        const fecha = toDateSafe(fechaInput);
        if (!fecha) return "-";

        const meses = [
            "enero", "febrero", "marzo", "abril", "mayo", "junio",
            "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
        ];

        const dia = fecha.getDate();
        const mes = meses[fecha.getMonth()];
        const año = fecha.getFullYear();

        const horas = String(fecha.getHours()).padStart(2, "0");
        const minutos = String(fecha.getMinutes()).padStart(2, "0");
        const segundos = String(fecha.getSeconds()).padStart(2, "0");

        return `${dia} de ${mes} del ${año} ${horas}:${minutos}:${segundos}`;
    }

    function fechaPlus48(fechaInput) {
        const fechaOriginal = toDateSafe(fechaInput);
        if (!fechaOriginal) return null;
        return new Date(fechaOriginal.getTime() + 48 * 60 * 60 * 1000);
    }

    function estaVencidaD(fechaInput) {
        const fechaOriginal = toDateSafe(fechaInput);
        if (!fechaOriginal) return true;
        const fechaVencimiento = new Date(fechaOriginal.getTime() + 48 * 60 * 60 * 1000);
        return new Date() > fechaVencimiento;
    }


    const handleEdit = (user) => {
        console.log("user", user)
        setEditingUser(user);


        const modal = new Modal(document.getElementById('exampleModal'));
        modal.show();
    };

    const totalPages = Math.ceil(total / limit);

    const getValue = (key, fallback = '') => editingUser?.[key] ?? fallback;

    const renderStatus = (status) =>{

        switch(status) {
            case "DONE":
                return ( <span className="bg-success-focus text-success-600 border border-success-main px-24 py-4 radius-4 fw-medium text-sm">
                                                TERMINADO
                                            </span> )
                break;
                case "QUEUED":
                return ( <span className="bg-warning-focus text-warning-600 border border-warning-main px-24 py-4 radius-4 fw-medium text-sm">
                                                EN COLA
                                            </span> )
                break;
                 case "DISPATCHED":
                return ( <span className="bg-info-focus text-info-600 border border-info-main px-24 py-4 radius-4 fw-medium text-sm">
                                                DESPACHADO
                                            </span> )
                break;
                case "RUNNING":
                return ( <span className="bg-info-focus text-info-600 border border-info-main px-24 py-4 radius-4 fw-medium text-sm">
                                                EN PROCESO
                                            </span> )
                break;
                case "FAILED":
                return ( <span className="bg-danger-focus text-danger-600 border border-danger-main px-24 py-4 radius-4 fw-medium text-sm">
                                                ERROR
                                            </span> )
                break;
        }


    }



    const renderFooter = () => {
        return (
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                <span>Mostrando {data.length} de {total} Registros</span>
                <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                    {/* Botón anterior */}
                    <li className="page-item">
                        <button
                            className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                            onClick={() => page > 1 && setPage(page - 1)}
                            disabled={page === 1}
                        >
                            <Icon icon="ep:d-arrow-left" />
                        </button>
                    </li>

                    {/* Calcular rango de páginas */}
                    {(() => {
                        const pagesToShow = 5;
                        let startPage = Math.max(1, page - Math.floor(pagesToShow / 2));
                        let endPage = startPage + pagesToShow - 1;

                        if (endPage > totalPages) {
                            endPage = totalPages;
                            startPage = Math.max(1, endPage - pagesToShow + 1);
                        }

                        const pageNumbers = [];
                        for (let i = startPage; i <= endPage; i++) {
                            pageNumbers.push(i);
                        }

                        return pageNumbers.map((num) => (
                            <li className="page-item" key={num}>
                                <button
                                    className={`page-link fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md ${page === num
                                        ? "bg-primary-600 text-white"
                                        : "bg-neutral-200 text-secondary-light"
                                        }`}
                                    onClick={() => setPage(num)}
                                >
                                    {num}
                                </button>
                            </li>
                        ));
                    })()}

                    {/* Botón siguiente */}
                    <li className="page-item">
                        <button
                            className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                            onClick={() => page < totalPages && setPage(page + 1)}
                            disabled={page === totalPages}
                        >
                            <Icon icon="ep:d-arrow-right" />
                        </button>
                    </li>
                </ul>
            </div>
        )
    }


    return (
        <>
            <div className="card h-100 p-0 radius-12">
                <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                    <div className="d-flex align-items-center flex-wrap gap-3">
                        <span className="text-md fw-medium text-secondary-light mb-0">Mostrar</span>
                        <select
                            className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
                            value={limit}
                            onChange={(e) => setLimit(parseInt(e.target.value))}
                        >
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                        </select>


                    </div>

                </div>
                <div className="card-body p-24">
                    <div className="table-responsive scroll-sm">
                        <table className="table bordered-table sm-table mb-0">
                            <thead>
                                <tr>
                                    <th scope="col">Fecha</th>
                                    <th scope="col">Estatus</th>
                                    <th scope="col">Tipo trabajo</th>
                                    <th scope="col">Fecha vencimiento</th>
                                    <th scope="col" className="text-center">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((e) => (
                                    <tr key={e.id}>
                                        <td>{formatearFecha(e.createdAt)}</td>

                                        <td>{ renderStatus(e.status)  }</td>


                                        <td>{e.tipo}</td>
                                        <td>{formatearFecha(fechaPlus48( e.finishedAt))}</td>
                                        <td className="text-center">
                                            <div className="d-flex align-items-center gap-10 justify-content-center">
                                                <button
                                                    type="button"
                                                    className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                    onClick={() => handleEdit(e)}
                                                >
                                                    <Icon icon="lucide:edit" className="menu-icon" />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    {renderFooter()}
                </div>
            </div>


            {/* Modal */}
            <div className="modal fade" id="exampleModal" tabIndex={-1} aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content radius-16 bg-base">
                        <div className="modal-header py-16 px-24 border-bottom">
                            <h5 className="modal-title">
                                Estatus del procesamiento de descarga
                            </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body p-24">
                            <form >

                                <div className="row">

                                    <div className="col-6 mb-20">
                                        <label className="form-label">Id</label>
                                        <div className="d-flex gap-2">
                                            <input
                                                type="text"
                                                name="autorizacion"
                                                required
                                                readOnly={true}
                                                className="form-control"
                                                defaultValue={getValue('id')} />
                                        </div>
                                    </div>

                                    <div className="col-12 mb-20">
                                        {renderStatus(getValue('status'))}
                                    </div>

                                    <div className="col-6 mb-20">
                                        <label className="form-label">Fecha solicitud</label>
                                        <div className="d-flex gap-2">
                                            <input
                                                type="text"
                                                name="autorizacion"
                                                required
                                                readOnly={true}
                                                className="form-control"
                                                value={formatearFecha(getValue('createdAt', null))} />
                                        </div>
                                    </div>

                                    <div className="col-6 mb-20">
                                        <label className="form-label">Tipo solicitud</label>
                                        <div className="d-flex gap-2">
                                            <input
                                                type="text"
                                                name="autorizacion2"
                                                required
                                                readOnly={true}
                                                className="form-control"
                                                defaultValue={  getValue('tipo')} />
                                        </div>
                                    </div>

                                    <div className="col-6 mb-20">
                                        <label className="form-label">fecha inicio procesamiento</label>
                                        <div className="d-flex gap-2">
                                            <input
                                                type="text"
                                                name="autorizacion"
                                                required
                                                readOnly={true}
                                                className="form-control"
                                                value={formatearFecha(getValue('startedAt', null))} />
                                        </div>
                                    </div>

                                    <div className="col-6 mb-20">
                                        <label className="form-label">fecha vencimiento</label>
                                        <div className="d-flex gap-2">
                                            <input
                                                type="text"
                                                name="autorizacion"
                                                required
                                                readOnly={true}
                                                className="form-control"
                                                value={formatearFecha( fechaPlus48(getValue('finishedAt', null)))}
                                            />
                                        </div>
                                    </div>

                                    {
                                        !estaVencidaD(getValue('finishedAt', null)) &&
                                        !!getValue('presignedUrl') && (
                                            <a
                                                href={getValue('presignedUrl')}
                                                className="btn btn-primary"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Descargar
                                            </a>
                                        )
                                    }

                                </div>
                                
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}